import type { ResolvedAssets, VideoFormat, VideoSpec } from './types';

export const FPS = 30;
/** Cross-fade overlap between consecutive scenes, in frames. */
export const OVERLAP = 12;
/** Narration starts this many frames into its scene. */
export const VOICE_DELAY = 10;

export const SIZES: Record<VideoFormat, { width: number; height: number }> = {
    landscape: { width: 1920, height: 1080 },
    portrait: { width: 1080, height: 1920 },
    square: { width: 1080, height: 1080 },
};

export interface TimedScene {
    index: number;
    from: number;
    frames: number;
}

/** Frame layout of every scene; scenes stretch to fit their narration. */
export function computeTimeline(spec: VideoSpec, assets?: ResolvedAssets) {
    const scenes: TimedScene[] = [];
    let cursor = 0;
    spec.scenes.forEach((s, i) => {
        const voice = spec.voice.enabled ? assets?.voice?.[s.id] : undefined;
        const minFrames = voice ? Math.ceil(voice.duration * FPS) + VOICE_DELAY + 18 : 0;
        const frames = Math.max(Math.round(s.duration * FPS), minFrames, OVERLAP * 3);
        const from = i === 0 ? 0 : cursor - OVERLAP;
        scenes.push({ index: i, from, frames });
        cursor = from + frames;
    });
    return { scenes, durationInFrames: Math.max(cursor, FPS), ...SIZES[spec.format] };
}
